export default __webpack_public_path__ + "e103712dde4ef2a3c7eb1358b4232040.svg";